module.exports = __webpack_public_path__ + "img/canvasMenu8.6dec7fe2.svg";